import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { API_BASE_URL } from './api.config';
import { unwrapPagedList } from './paged-list';
import { WorkOrder, WorkOrderListItem, WorkOrderRow, WorkOrderSearchRequest } from '../../shared/models/work-order';

@Injectable({ providedIn: 'root' })
export class WorkOrderService {
  constructor(private readonly http: HttpClient) {}

  search(request: WorkOrderSearchRequest = { Page: 1, PageSize: 50 }) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/WorkOrderListSearch`, request).pipe(
      map(raw => unwrapPagedList<WorkOrderListItem>(raw))
    );
  }

  get(id: string | number) {
    return this.http.get<WorkOrder>(`${API_BASE_URL}/mobile/GetWorkOrder/${encodeURIComponent(String(id))}`);
  }

  getRow(id: string | number) {
    return this.http.get<WorkOrderRow>(`${API_BASE_URL}/mobile/GetWorkOrderRow/${encodeURIComponent(String(id))}`);
  }

  editRow(row: WorkOrderRow) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/EditWorkOrderRow`, row);
  }

  deleteRow(id: string | number) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/DeleteWorkOrderRow/${encodeURIComponent(String(id))}`, {});
  }
}
